export default {
    title: 'Omiljeni',
    selected: 'označenih',
    remove: 'Ukloni',
    allCategories: 'Sve kategorije',
    product: {
        addToCart: 'Dodaj u korpu',
        notifyMe: 'Obavijesti me',
        removeSuccessMessage: 'Proizvod je uspješno uklonjen sa Vaše liste želja.',
        removeMultipleSuccessMessage: 'Proizvodi su uspješno uklonjeni sa Vaše liste želja.'
    }
}
